module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAANCAYAAABPeYUaAAAA3UlEQVQ4T9WSLU6DURBFz9lAFdVsgECqWAAGJII1QBpETR0hGAIOEOVnB2BqmxpU01pWwAaKwEMyZMj7kg8CtCmqY+fOeXfuGyMi+EeZFREDYHsBzhQ4Ua/N4YjYBG6A1hywd+BYPau06eRO3S+wXeACWP0FdqV2inYHOFc3EpKZvBRrvSI4BE6BRoE9AAfqa0SsAZfAVvaqTOrBPgNdtV9gR8CjOo6IJpCP7NVd/gSp+k9AW50U2C3wufL3+gtSaUfAem2thSAzP2seJ0sIyeNamen7qyAv/Q24V4cfrgdhDj3bSNEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-emil.png
// module id = izw2
// module chunks = 0